import React, { useState, useRef, useEffect } from 'react';

const FilterGroup = ({ title, items, selectedItems, onChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const filterBoxRef = useRef(null);
  const maxVisibleItems = 5; // You can customize this if needed

  const handleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (filterBoxRef.current) {
      const scrollHeight = filterBoxRef.current.scrollHeight;
      if (isExpanded) {
        filterBoxRef.current.style.maxHeight = `${scrollHeight}px`;
        filterBoxRef.current.style.opacity = '1';
      } else {
        filterBoxRef.current.style.maxHeight = '100px'; // Set fixed height here
        filterBoxRef.current.style.opacity = '1';
      }
    }
  }, [isExpanded, items.length]);

  return (
    <div className="filterGroup">
      <h3>{title}</h3>
      <div
        ref={filterBoxRef}
        className="filterBox"
        style={{
          maxHeight: '100px', // Initial fixed height
          overflow: 'hidden',
          opacity: '1', // Ensure content is visible by default
          transition: 'max-height 0.3s ease, opacity 0.3s ease',
        }}
      >
        {items.map((item) => (
         <label key={item} className="checkbox-label">
         <span className="checkbox-wrapper">
           <input
             type="checkbox"
             checked={selectedItems.includes(item)}
             onChange={() => onChange(item)}
           />
           <span className="custom-checkbox"></span> {/* Custom checkbox styling */}
         </span>
         <span className="label-text">{item}</span>
       </label>
        ))}
      </div>
      {items.length > maxVisibleItems && (
        <button
          className="show-more-button"
          onClick={handleExpandCollapse}
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </button>
      )}
    </div>
  );
};

export default FilterGroup; 